import { render, staticRenderFns } from "./Manage-Motor-Settings.vue?vue&type=template&id=40090a1c"
import script from "./Manage-Motor-Settings.vue?vue&type=script&lang=js"
export * from "./Manage-Motor-Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports